if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber?.();
        this.cartUpdateUnsubscriber?.();
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        const productUrl = target.dataset.productUrl || this.dataset.url;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues),
          callback: this.handleUpdateProductInfo(productUrl),
        });
      }

      buildRequestUrlWithParams(url, optionValues) {
        const params = [`section_id=${this.sectionId}`];

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      renderProductInfo({ requestUrl, callback }) {
        fetch(requestUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .catch((error) => console.error(error));
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updatePrice(html);
          this.updateBlock(html, 'Inventory');
          this.updateBlock(html, 'Sku');
          this.updateBlock(html, 'Quantity-Form');
          this.updateBlock(html, 'Volume');
          this.updateBlock(html, 'Price-Per-Item');
          this.updateBlock(html, 'PreorderMessage');
          this.updateBlock(html, 'VitalsShippingWrapper');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? false,
            window.variantStrings.soldOut
          );

          this.updateVatToggle();

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      getSelectedVariant(html) {
        const selectedVariant = html.querySelector('variant-selects [data-selected-variant]')?.textContent;
        return selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      updatePrice(html) {
        const source = html.getElementById(`price-${this.sectionId}`);
        const destination = this.querySelector(`#price-${this.dataset.section}`);

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
        }
      }

      updateBlock(html, id) {
        const source = html.getElementById(`${id}-${this.sectionId}`);
        const destination = this.querySelector(`#${id}-${this.dataset.section}`);

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          destination.classList.toggle('hidden', source.classList.contains('hidden'));
        }
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          if (!input) return;

          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume', 'Quantity-Form'].forEach((id) => {
          this.querySelector(`#${id}-${this.dataset.section}`)?.classList.add('hidden');
        });
      }

      updateVatToggle() {
        const toggle = this.querySelector('.vat-toggle-input') || document.querySelector('.vat-toggle-input');
        const wrappers = this.querySelectorAll('.vat-price-wrapper');

        wrappers.forEach((wrapper) => {
          const incl = wrapper.querySelector('.incl-vat');
          const excl = wrapper.querySelector('.ex-vat');

          if (!incl || !excl) return;

          if (toggle && toggle.checked) {
            incl.style.display = 'none';
            excl.style.display = '';
          } else {
            incl.style.display = '';
            excl.style.display = 'none';
          }
        });
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
      }

      get productForm() {
        return this.querySelector('product-form');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

document.addEventListener('change', function (event) {
  const input = event.target;

  if (!input.classList || !input.classList.contains('vat-toggle-input')) return;

  document.querySelectorAll('.vat-price-wrapper').forEach((wrapper) => {
    const incl = wrapper.querySelector('.incl-vat');
    const excl = wrapper.querySelector('.ex-vat');

    if (!incl || !excl) return;

    if (input.checked) {
      incl.style.display = 'none';
      excl.style.display = '';
    } else {
      incl.style.display = '';
      excl.style.display = 'none';
    }
  });
});